(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-play-spela/assets/system-selector/system-selector-component.js') >= 0) return;  svs.modules.push('/components/tipsen/route-play-spela/assets/system-selector/system-selector-component.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const MIN_SYSTEMS = 5;
const DISPLAY_COUNT = 5;
const COLUMN_SIZE = 1;
const SYSTEM_CHOOSE = 'Visa systemvarianter';
const _React = React,
  useState = _React.useState,
  useMemo = _React.useMemo;
const _svs$components$sport = svs.components.sport.systems,
  getSystemLabelFromNumber = _svs$components$sport.getSystemLabelFromNumber,
  getSystemFromNumber = _svs$components$sport.getSystemFromNumber;
const SystemExplanation = svs.components.tipsen.routePlaySpela.systemSelector.SystemExplanation;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const getSystemAriaLabel = systemNum => {
  const system = getSystemFromNumber(systemNum);
  const systemType = system.systemType,
    numFullHedges = system.numFullHedges,
    numHalfHedges = system.numHalfHedges;
  const guarantyText = system.guaranty ? ", ".concat(system.guaranty, " nyckelrader.") : '.';
  return "".concat(systemType, ", ").concat(numFullHedges, ", ").concat(numHalfHedges, ", ").concat(system.rows.length, ", ").concat(numFullHedges, " hel garderingar, ").concat(numHalfHedges, " halv garderingar, ").concat(system.rows.length, " rader").concat(guarantyText);
};
const SystemSelectorComponent = _ref => {
  let systems = _ref.systems,
    selectedSystem = _ref.system,
    systemType = _ref.systemType,
    onClick = _ref.onClick,
    selectedItem = _ref.selectedItem;
  const isExtraSmall = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAllSystems = _useState2[0],
    setShowAllSystems = _useState2[1];
  const onToggleShowAllSystems = () => {
    setShowAllSystems(previousState => !previousState);
  };
  const systemsToShow = useMemo(() => {
    if (showAllSystems) {
      return systems;
    }
    const collapsedIndex = systems.indexOf(selectedSystem);
    const displayShift = Math.ceil(DISPLAY_COUNT / 2) + Math.floor(COLUMN_SIZE / 2) - collapsedIndex % COLUMN_SIZE; 
    let minIndex = Math.max(collapsedIndex + displayShift - DISPLAY_COUNT, 0);
    const maxIndex = Math.min(minIndex + DISPLAY_COUNT, systems.length);
    if (maxIndex - minIndex < DISPLAY_COUNT) {
      minIndex = Math.max(maxIndex - DISPLAY_COUNT, 0);
    }
    return systems.slice(minIndex, maxIndex);
  }, [systems, showAllSystems, selectedSystem]);
  const _useMemo = useMemo(() => {
      const first = systemsToShow.slice(0, MIN_SYSTEMS);
      const rest = systemsToShow.slice(MIN_SYSTEMS);
      return [first, rest];
    }, [systemsToShow]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    firstSystems = _useMemo2[0],
    remainingSystems = _useMemo2[1];
  if (!isExtraSmall) {
    return React.createElement(React.Fragment, null, React.createElement(SystemExplanation, {
      selectedItem: selectedItem,
      selectedSystem: selectedSystem
    }), React.createElement("div", {
      className: "pg_system_selector",
      role: "radiogroup"
    }, React.createElement("div", {
      className: "pg_system_selector__btns"
    }, React.createElement("div", {
      className: "pg_system_selector__btns__initial"
    }, firstSystems.map(systemNum => React.createElement("label", {
      "aria-checked": systemNum === selectedSystem,
      "aria-label": getSystemAriaLabel(systemNum),
      className: "f-200 pg_system_selector__btns__btn",
      htmlFor: systemNum,
      key: systemNum
    }, getSystemLabelFromNumber(systemNum), React.createElement("input", {
      "aria-checked": systemNum === selectedSystem,
      checked: systemNum === selectedSystem,
      className: "sr-only",
      id: systemNum,
      name: systemNum,
      onChange: () => {
        onClick(systemType, systemNum);
      },
      type: "radio"
    })))), showAllSystems && React.createElement("div", {
      className: "pg_system_selector__btns__expandable",
      id: "expandable-systems"
    }, remainingSystems.map(systemNum => React.createElement("label", {
      "aria-checked": systemNum === selectedSystem,
      "aria-label": getSystemAriaLabel(systemNum),
      className: "f-200 pg_system_selector__btns__btn",
      htmlFor: systemNum,
      key: systemNum
    }, getSystemLabelFromNumber(systemNum), React.createElement("input", {
      "aria-checked": systemNum === selectedSystem,
      checked: systemNum === selectedSystem,
      className: "sr-only",
      id: systemNum,
      name: systemNum,
      onChange: () => {
        onClick(systemType, systemNum);
      },
      type: "radio"
    }))))), systems.length > MIN_SYSTEMS && React.createElement("div", {
      className: "pg_system_selector__show_all"
    }, React.createElement("label", {
      className: "f-300 margin-half system-selector-button f-bold pg_system_selector__btns__btn",
      htmlFor: "showAllSystems"
    }, showAllSystems ? 'Visa färre' : 'Visa alla', React.createElement("input", {
      "aria-controls": "expandable-systems",
      "aria-expanded": showAllSystems,
      className: "sr-only",
      id: "showAllSystems",
      onClick: onToggleShowAllSystems,
      type: "button"
    })))));
  }
  return React.createElement(React.Fragment, null, React.createElement(Form, {
    isVertical: true
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    "data-testid": "system-selector",
    onChange: event => onClick(systemType, Number(event.target.value)),
    v2: true,
    value: selectedSystem || SYSTEM_CHOOSE
  }, React.createElement(Option, {
    value: ""
  }, SYSTEM_CHOOSE), systems.map(systemNum => React.createElement(Option, {
    key: systemNum,
    value: systemNum
  }, getSystemLabelFromNumber(systemNum)))))), React.createElement(SystemExplanation, {
    selectedItem: selectedItem,
    selectedSystem: selectedSystem
  }));
};
setGlobal('svs.components.tipsen.routePlaySpela.systemSelector.SystemSelectorComponent', SystemSelectorComponent);

 })(window);